// Borna bug batch 1 (items 4 + 8): the ONE way a Borna surface asks for
// logout. Every entry point (the student sidebar row, the mobile bottom-nav
// item) mixes this in, so there is exactly one confirmation behaviour and
// exactly one logout call -- the existing `AuthService.logout`, whose auth and
// session semantics are untouched.
//
// `requestLogout` only raises the shared dialog; `App/index.vue` renders that
// dialog once and owns confirm/cancel, so nothing here duplicates it.
export default {
  methods: {
    requestLogout() {
      this.$store.dispatch('app/logoutConfirm/show')
    },
  },
}
